import React, { useEffect, useState } from 'react'
import { reportPost, getTypeOfReports, reportUser, reportUserZoneRoom } from '../../actions/userActions';
import { connect } from 'react-redux'
import { UseComponentVisible } from '../UseComponentVisible'
import Button from '../../utils/components/Button/Button';
import style from './ModalReportPost.module.css'
import InputTextArea from '../../utils/components/InputTextArea/InputTextArea';
const ModalReportContent = ({ reportType, communityID, idReported, displayModal, reportUserZoneRoom, closeModal, reportPost, reportUser, getTypeOfReports, typeOfReports, isLoadingTypeOfReports }) => {

    useEffect(() => {
        getTypeOfReports()
    }, [])

    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = UseComponentVisible(false);

    const [descriptionReport, setDescriptionReport] = useState('')
    const [nameReport, setNameReport] = useState('')
    const [description, setDescription] = useState('')
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    };
    const close = (e) => {
        e.stopPropagation()
        closeModal(e)
    }
    return (
        <div
            className="modal "
            onClick={close}
            style={divStyle} >
            <div
                className="modal-content modal-report-post"
                onClick={e => e.stopPropagation()} >
                <div>

                    <div className="parent-width relative" ref={ref}>
                        <div className="column parent-width centerContent">
                            <div className={style.report_title}>
                                ¿ Por que quieres reportar?
                            </div>
                        </div>
                        <div className={style.report_btn_container}>
                            {isLoadingTypeOfReports ? <div></div> :
                                typeOfReports.map((activity) => (
                                    <Button onClick={() => {
                                        setDescriptionReport(activity._id)
                                        setNameReport(activity.description)
                                    }}
                                        key={activity._id}
                                        text={activity.description}
                                        active={activity._id ===descriptionReport}

                                    />


                                ))
                            }
                        </div>

                    </div>
                    <InputTextArea
                        type="text"
                        name="description"
                        value={description}
                        setValue={setDescription}
                        placeholder={'Descripción'}
                    />
                    <div className="column parent-width centerContent">
                        <Button onClick={(e) => {
                            if (descriptionReport !== "" && description !== "") {
                                switch (reportType) {
                                    case "content":
                                        reportPost({ contentID: idReported, typeOfReportsIDS: [descriptionReport], description: description })
                                        break;
                                    case "user":
                                        reportUser({ reportedEntityID: idReported, typeOfReportsIDS: [descriptionReport], description: description })
                                        break
                                    case "userChat":
                                        reportUserZoneRoom({ communityID, reportedID: idReported, typeOfReportsIDS: [descriptionReport], description: description })
                                        break
                                    case "userZone":
                                        reportUserZoneRoom({ communityID, reportedID: idReported, typeOfReportsIDS: [descriptionReport], description: description })
                                        break
                                    case "postZone":
                                        reportUserZoneRoom({ communityID, reportedID: idReported, typeOfReportsIDS: [descriptionReport], description: description })
                                        break
                                    default:
                                        break;
                                }
                            }
                            close(e)
                        }}
                            text='Reportar'
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
    return {
        isLoadingTypeOfReports: state.userInfo.isLoadingTypeOfReports,
        typeOfReports: state.userInfo.typeOfReports
    }
}

export default connect(mapStateToProps, { reportPost, reportUser, reportUserZoneRoom, getTypeOfReports })(ModalReportContent);